import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import SuggestLinkCard from '@/components/format-edit/SuggestLinkCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AtenaLabelSuggest',
  props: {
    linkId: null,
    frm: null,
    lead: null
  },
  setup(__props: any) {

const props = __props as {
  /** GTM の link_click で入口を区別する id */
  linkId: string
  /** 遷移先に付ける計測用の frm。GA4 の page_location で流入元を数える */
  frm: string
  lead: string
};



const href = computed(
  () => `/format/atena?frm=${encodeURIComponent(props.frm)}`
)

return { __sfc: true,props, href, SuggestLinkCard }
}

})